/**
 * Toast PR: quiet screen-only 「· 저장됨」 marker next to 「다른 공유」.
 * Set only after an image save succeeds; cleared by the next user action.
 * Never part of the share VM, Copy, PNG, OG or #/h/ data.
 */
let saved = false

export function markImageSaved(): void {
  saved = true
}

export function isImageSavedMarked(): boolean {
  return saved
}

/**
 * Keep 「다른 공유」 on one line with 0 layout shift: if heading + marker do
 * not fit (long locales at 223), the marker drops just under the heading as
 * an overlay (absolute) instead of wrapping the heading or growing the row.
 */
export function fitSavedMarks(): void {
  for (const m of document.querySelectorAll<HTMLElement>('.shareSavedMark')) {
    const sm = m.parentElement
    if (!sm) continue
    m.classList.remove('shareSavedMarkBelow')
    if (sm.scrollWidth > sm.clientWidth + 0.5) m.classList.add('shareSavedMarkBelow')
  }
}

function clearOnNextAction(): void {
  if (!saved) return
  saved = false
  for (const m of document.querySelectorAll('.shareSavedMark')) m.remove()
}

/** Character input only: never navigation/scroll keys or modifiers alone. */
export function isCharacterKey(e: Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey' | 'altKey'>): boolean {
  return e.key.length === 1 && e.key !== ' ' && !e.ctrlKey && !e.metaKey && !e.altKey
}

/** A tap is a pointer that moved less than this (scroll drags move more). */
export const TAP_SLOP_PX = 10
let down: { id: number; x: number; y: number } | null = null

// Scrolling never clears the marker: no wheel / touchstart / touchmove /
// scroll / pointerdown handling. Only a tap, a click or a character key does.
if (typeof addEventListener === 'function') {
  addEventListener('resize', fitSavedMarks)
  addEventListener('pointerdown', (e) => { down = { id: e.pointerId, x: e.clientX, y: e.clientY } }, { capture: true, passive: true })
  addEventListener('pointercancel', () => { down = null }, { capture: true, passive: true })
  addEventListener('pointerup', (e) => {
    const d = down
    down = null
    if (d && d.id === e.pointerId && Math.hypot(e.clientX - d.x, e.clientY - d.y) < TAP_SLOP_PX) clearOnNextAction()
  }, { capture: true, passive: true })
  addEventListener('click', clearOnNextAction, true)
  addEventListener('keydown', (e) => { if (isCharacterKey(e)) clearOnNextAction() }, true)
}
